module.exports = __webpack_public_path__ + "static/placeholder-42b4b24fb555de01dc3e13f85ee64c23.png";